import { Config } from '../config';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpClient } from '@angular/common/http';
import { PaginatedResponse } from '../models/paginated-response.model';
import { ProductBrandModel, ProductCategoryModel, ProductModel } from '../models/wardrobe.model';
import { ProductColorModel, ProductListingParamsModel, ProductSizeModel, ProductConditionModel, OfferDetailModel } from './../models/wardrobe.model';

@Injectable({
  providedIn: 'root'
})
export class WardrobeService extends HttpService {

  constructor(
    http: HttpClient,
  ) {
    super(http);
  }

  createProduct(product: ProductModel) {
    return this.http.post<ProductModel>(`${Config.apiUrl}/products/save`, product);
  }

  updateProduct(id: number, product: ProductModel) {
    return this.http.put<ProductModel>(`${Config.apiUrl}/products/${id}`, product);
  }

  productsList(params: ProductListingParamsModel) {
    return this.http.get<PaginatedResponse<ProductModel>>(`${Config.apiUrl}/products/list`, {
      params: this.serialize(params)
    });
  }

  productDetail(id: number) {
    return this.http.get<ProductModel>(`${Config.apiUrl}/products/detail/${id}`);
  }

  deleteProduct(id: number) {
    return this.http.delete(`${Config.apiUrl}/products/${id}`);
  }

  removeProductBackground(body) {
    return this.http.post(`${Config.apiUrl}/media/remove-background`, body);
  }

  categoriesList(params: { page: number, per_page?: number }) {
    return this.http.get<PaginatedResponse<ProductCategoryModel>>(`${Config.apiUrl}/categories/list`, {
      params: this.serialize(params)
    });
  }

  mainCategoriesList(params: { page: number, per_page?: number }) {
    return this.http.get<PaginatedResponse<ProductCategoryModel>>(`${Config.apiUrl}/categories/main-list`, {
      params: this.serialize(params)
    });
  }

  categoryDetail(id: number) {
    return this.http.get<ProductCategoryModel>(`${Config.apiUrl}/categories/detail/${id}`);
  }

  brandsList(params: any) {
    return this.http.get<PaginatedResponse<ProductBrandModel>>(`${Config.apiUrl}/brand/list`, {
      params: this.serialize(params)
    });
  }

  createBranch(brand: { name: string }) {
    return this.http.post<PaginatedResponse<ProductBrandModel>>(`${Config.apiUrl}/brand/create`, brand);
  }

  colorsList(params: { page: number, per_page?: number }) {
    return this.http.get<PaginatedResponse<ProductColorModel>>(`${Config.apiUrl}/color/list`, {
      params: this.serialize(params)
    });
  }

  conditionsList(params?: { page: number, per_page?: number }) {
    return this.http.get<PaginatedResponse<ProductConditionModel>>(`${Config.apiUrl}/condition/list`, {
      params: this.serialize(params)
    });
  }

  typesList(params: { page: number, per_page?: number }) {
    return this.http.get<PaginatedResponse<ProductColorModel>>(`${Config.apiUrl}/type/list`, {
      params: this.serialize(params)
    });
  }

  offerList(params: { page: number, product_id: number }) {
    return this.http.get<PaginatedResponse<OfferDetailModel>>(`${Config.apiUrl}/offers/list`, {
      params: this.serialize(params)
    });
  }

  productSizesList(params: { type_id?: number, category_id?: number }) {
    return this.http.get<Array<ProductSizeModel>>(`${Config.apiUrl}/products/sizes`, {
      params: this.serialize(params)
    });
  }

}
